module.exports = __webpack_public_path__ + "static/media/database.367210d5.svg";